import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-alumni',
  templateUrl: './alumni.component.html',
  styleUrls: ['./alumni.component.scss']
})
export class AlumniComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    margin: 20,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<', '>'],
    autoplay: true,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: true
  }
  testimonial = [
    {
      id: 1,
      name: 'Tarun Pant',
      position: 'BBA-1st shift 2016-19 Batch, Presently pursuing Masters In Management ( in Risk and Financial Technology) , Neoma Business School, Mont Saint Aignan, France.',
      imgUrl: '/assets/img/alumnis/1.jpg',
      degree: '',
      description: 'IIMT is much beyond just an Institution. It actually denotes a Culture: a Culture of excellence, empowerment, and enrichment. Being a part of IIMT, I felt blessed. The college has moulded my personality well and clarified my vision of the future. Just want to thank the wonderful faculty of IIMT.'
    },
    {
      id: 2,
      name: 'Vuzmal Nehru',
      position: 'BA LLB- 2013-18 Batch, presently working as an Advocate at Tis Hazari Courts',
      imgUrl: '/assets/img/alumnis/2.jpg',
      degree: '',
      description: 'IIMT has been an Institute of educational as well as moral inculcations. Proud to be part of IIMT family and I wish one day I make IIMT proud being its alumni.'
    },
    {
      id: 3,
      name: 'Tanya Gupta',
      position: 'BBA-1st shift 2016-19 Batch, later pursued PGDM from JIMS, Kalkaji',
      imgUrl: '/assets/img/alumnis/four.jpg',
      degree: '',
      description: 'Great Experience in terms of gaining knowledge and developing a corporate personality and good amount of exposure to industries.'
    },
    {
      id: 4,
      name: 'Shweta Puneyani Khurana',
      position: 'BBA Cam -1st shift, 2011-14 Batch, presently working as Projector Co-ordinator at Intel - Onsumaye Web Solutions Pvt. Ltd.',
      imgUrl: '/assets/img/alumnis/five.jpg',
      degree: '',
      description: 'It was really a great and unforgettable experience. Although we have moved to some bigger organization but still we remember this institute as the knowledge provider which we are applying now in the corporate jobs. I would really recommend this institute for giving us a friendly culture where everyone is easily approachable starting from the teachers to the dean.'
    },
    {
      id: 5,
      name: 'Shweta Singh',
      position: 'BBA- Gen- 2nd Shift,  2016-19 Batch , later pursued Diploma in Banking & Finance from Indian Institute of Banking and Finance.',
      imgUrl: '/assets/img/alumnis/six.jpg',
      degree: '',
      description: 'The faculty is the USP of this college. The teachers give their best to the students in terms o knowledge and guidance.'
    },
    {
      id: 6,
      name: 'Shivam Sharma',
      position: 'BBA –Gen- 2nd Shift, 2015-18 Batch, presently working in Berger Paints',
      imgUrl: '/assets/img/alumnis/seven.jpg',
      degree: '',
      description: 'BBA- Gen- 2nd Shift,  2016-19 Batch , later pursued Diploma in Banking & Finance from Indian Institute of Banking and Finance.'
    },
    {
      id: 7,
      name: 'Samarth Gandotra',
      position: 'BBA- 2nd shift, 2015-18 batch. Later pursued LLB from IME College, Ghaziabad.',
      imgUrl: '/assets/img/alumnis/eight.jpg',
      degree: '',
      description: 'My best part of life was in IIMT, I had a total transformation from how I was earlier in a pragmatic way, the love I got from teachers was beyond expressable.'
    },
    {
      id: 8,
      name: 'Riya Gupta',
      position: 'BBA Cam-1st shift, 2016-19 batch, later pursued PGDM from Birla institute of Management & Technology.',
      imgUrl: '/assets/img/alumnis/nine.jpg',
      degree: '',
      description: 'With IIMT I have had the best experience of my life as it has helped me in growing in my personal as well as professional career.'
    },
    {
      id: 9,
      name: 'Piyush',
      position: 'BBA Cam, 2016-19 batch.',
      imgUrl: '/assets/img/alumnis/ten.jpg',
      degree: '',
      description: 'My experience in IIMT was simply more than amazing. I have learnt a lot of things there which have really enhanced my personality and my knowledge. Also the faculty members are so nice and helped me a lot to grow my skills. Thank You IIMT for everything.'
    },
    {
      id: 10,
      name: 'Katyayani Anand',
      position: 'BALLB, 2012-15 batch, later did LLM from USLLDS and PGD in ADR from Indian Law institute , presently working as Task based consultant NCPCR.',
      imgUrl: '/assets/img/alumnis/elven.jpg',
      degree: '',
      description: 'My experience in IIMT has been great. Can\'t thank enough my teachers throughout my course for being so patient, kind and helpful at each and every step.'
    },
    {
      id: 11,
      name: 'Nityam Singh',
      position: 'BBA CAM 2nd Shift, 2018-21 batch, presently working as Product Analyst at ARTHMATE.',
      imgUrl: '/assets/img/alumnis/twelve.jpg',
      degree: '',
      description: 'Teachers were helpful through the journey, they were humble and knowledgeable. Has a great experience.'
    },
    {
      id: 12,
      name: 'Nitin Narang',
      position: 'BBA- 2nd shift, 2014-17 Batch, presently working as CXQO Associate at Amazon',
      imgUrl: '/assets/img/alumnis/thrteen.jpg',
      degree: '',
      description: 'It was a great journey. Being the topper of my batch for 3 years and participating in other co-curricular activities under the guidance of my professors was no less than a blessing. IIMT helped me in improving my personality in such a way that it changed my way of seeing the life.'
    },
    {
      id: 13,
      name: 'Muskan Tandon',
      position: 'BBA 2nd shift 2017-20 Batch, presently working as HR executive with Sinzo.',
      imgUrl: '/assets/img/alumnis/fourten.jpg',
      degree: '',
      description: 'It was an amazing experience where I grown up myself with better skills with the support of excellent teachers and my friends, a memorable experience I had gained over here.'
    },
    {
      id: 14,
      name: 'Himanshu Diwakar',
      position: 'BBA-1st shift, 2018-21 Batch, presently pursuing MBA from MERI',
      imgUrl: '/assets/img/alumnis/fivten.jpg',
      degree: '',
      description: 'Very good college, good alumni support and placement Assistance!'
    },
    {
      id: 15,
      name: 'Hardik Bansal',
      position: 'BBA-2nd shift, 2014-17 Batch, presently working as senior accountant at Nissan HQ.',
      imgUrl: '/assets/img/alumnis/sixteen.jpg',
      degree: '',
      description: 'A very good college to learn and explore your boundaries and knowledge and a supportive staff ready for help every time needed.'
    },
    {
      id: 16,
      name: 'Deep Luthra',
      position: 'BBA Cam- 1st shift, 2016-19 Batch, later pursued LLB from IMS Noida.',
      imgUrl: '/assets/img/alumnis/seventen.jpg',
      degree: '',
      description: 'It was very pleasant experience in his college with a very knowledgeable staff who was always ready to help and facilities we have in this college.'
    },
    {
      id: 17,
      name: 'Ashutosh Aggarwal',
      position: 'BBA CAM-2nd shift, 2016-19 Batch, later pursued PGDM from JIMS, Kalkaji.',
      imgUrl: '/assets/img/alumnis/eigteen.jpg',
      degree: '',
      description: 'When I Joined this college I was not sure that what I am going to do in future but here teachers, my friends, fellow classmates and director sir all helped in taking this decision My experience was superb and amazing. Three years had gone like air.'
    }
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
